import { tabs } from 'vue-strap'

export default {
    extends: tabs,
    mounted () {
        this.syncAccessibility()
        this.$el.addEventListener('keydown', this.onTabKey)
    },
    updated () { this.syncAccessibility() },
    beforeDestroy () { this.$el.removeEventListener('keydown', this.onTabKey) },
    methods: {
        syncAccessibility () {
            const links = this.$el.querySelectorAll('ul.nav > li > a')
            Array.prototype.forEach.call(links, (link, index) => {
                const tab = this.tabs[index]
                if (!tab) return
                const id = 'tone-tab-' + this._uid + '-' + index
                link.id = id
                link.parentElement.setAttribute('role', 'presentation')
                link.setAttribute('role', 'tab')
                link.setAttribute('aria-selected', tab === this.show ? 'true' : 'false')
                link.setAttribute('aria-disabled', tab.disabled ? 'true' : 'false')
                link.setAttribute('tabindex', tab === this.show ? '0' : '-1')
                link.setAttribute('aria-controls', id + '-panel')
                tab.$el.id = id + '-panel'
                tab.$el.setAttribute('aria-labelledby', id)
                tab.$el.setAttribute('tabindex', '0')
            })
        },
        onTabKey (event) {
            const links = Array.prototype.slice.call(this.$el.querySelectorAll('[role="tab"]'))
            const index = links.indexOf(event.target)
            if (index === -1) return
            const available = links.filter(link => link.getAttribute('aria-disabled') !== 'true')
            const current = available.indexOf(event.target)
            let next
            if (event.key === 'ArrowRight') next = available[(current + 1) % available.length]
            if (event.key === 'ArrowLeft') next = available[(current - 1 + available.length) % available.length]
            if (event.key === 'Home') next = available[0]
            if (event.key === 'End') next = available[available.length - 1]
            if (next) {
                event.preventDefault()
                links.forEach(link => link.setAttribute('tabindex', link === next ? '0' : '-1'))
                next.focus()
            }
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault()
                if (!event.repeat) event.target.click()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/accessibility/Tabs.js